import { useTranslation } from 'react-i18next';

const icons = [
  'ri-home-4-line',
  'ri-tools-line',
  'ri-shield-star-line',
  'ri-stack-line',
  'ri-search-line',
  'ri-snowy-line',
];

export default function ServicesQuartier() {
  const { t } = useTranslation('saintromuald');

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-manrope font-bold text-slate-primary text-center mb-10 md:mb-14">
          {t('services_h2')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-soft-gray rounded-lg p-5 md:p-6"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-copper/10 shrink-0">
                <i className={`${icons[i - 1]} text-copper text-lg`} />
              </span>
              <p className="text-sm md:text-base text-slate-primary font-medium pt-2">
                {t(`service_${i}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}